import React, { Component } from 'react'
import { translate } from "react-i18next"

import './StaffPicture.css'

class StaffPicture extends Component {
  render() {
    const { staffField, business, t } = this.props

    let staff = null
    if(staffField && staffField.value && staffField.value !== 'any') {
      staff = business.staffs.find(s => s.id === staffField.value)
    }

    let pictureUrl = staff && staff.picture && staff.picture.url
    if (!pictureUrl) {
      pictureUrl = staff && staff.user && staff.user.pictureUrl
    }

    if (!pictureUrl) {
      return null
    }

    return (
      <div className="selected-staff">
        <div className="staff-name">
          <strong>{ t('staff') }</strong><br/>
          <span>{ staff.name.replace(' ', '\n') }</span>
        </div>
        <div className="staff-picture" style={ { backgroundImage: `url(${pictureUrl})` } } />
      </div>
    );
  }
}

export default translate("translations")(StaffPicture)
